<svg
  width="322"
  height="80"
  viewBox="0 0 322 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <path
    fill="currentColor"
    d="M78.3566 45.2259C78.6114 43.3624 78.7411 41.72 78.7411 40.2047C78.7411 29.16 74.9059 19.7106 67.2263 11.9224C59.5097 4.1106 50.2553 0.200012 39.3937 0.200012C28.495 0.200012 19.2174 4.1106 11.5286 11.9224C3.84905 19.7106 0 29.16 0 40.2047C0 41.8847 0.1019 43.5977 0.32886 45.3482C5.5304 43.4847 10.8477 42.0682 16.3689 41.033H16.4847C16.9571 34.1482 19.2869 28.5906 23.4695 24.3459C27.7724 19.9741 32.974 17.7718 39.0648 17.7718C45.1557 17.7718 50.3526 19.9741 54.637 24.3459C58.9632 28.7082 61.1216 34.0118 61.1216 40.2V40.7459C61.6265 40.8306 62.136 40.9341 62.6084 41.0282C68.0137 42.0259 73.257 43.4235 78.3612 45.2165"
  />
  <path
    fill="currentColor"
    d="M74.3593 58.6424C75.0772 57.4142 75.6515 56.0542 76.1935 54.5624L73.8683 54.1342H73.8081C68.7362 53.2777 63.3633 52.7883 57.7125 52.7036L55.517 52.6471C48.912 52.7318 42.3765 53.2777 35.8873 54.3365L30.607 55.2683C22.1539 56.9859 14.164 59.3906 6.71606 62.44C8.71701 65.4847 11.1256 68.2565 13.9556 70.6847C18.5319 68.5389 23.4138 66.6047 28.6107 64.8636L29.94 64.44C31.8623 63.7765 33.5668 63.273 35.086 62.873C45.6049 60.0118 55.8273 58.5012 65.7765 58.3553H66.9993C68.3518 58.3553 70.2833 58.4212 72.84 58.5577L74.3685 58.6424H74.3593Z"
  />
  <path
    fill="currentColor"
    d="M76.0222 50.9388L77.1756 51.2259L77.9259 47.9929C72.4882 46.2 66.8466 44.8023 61.0475 43.8282C54.0535 42.6329 46.8047 42.0353 39.3428 42.0353C31.8578 42.0353 24.5719 42.6329 17.5964 43.8282C11.7834 44.7976 6.15576 46.1953 0.699463 47.9929C1.27381 50.7976 2.06122 53.4423 3.06169 55.9412C12.9877 52.1294 23.5761 49.6494 34.7804 48.487C37.3789 48.2235 39.315 48.0541 40.6351 47.9929L42.0524 47.9129C44.2016 47.8329 46.3044 47.7812 48.3888 47.7812H48.9353C52.2795 47.7812 55.9108 47.9129 59.8525 48.2235C65.5682 48.7741 70.9458 49.6823 76.0269 50.9388"
  />
  <path
    fill="currentColor"
    d="M26.1328 76.0495L23.9744 77.16C28.8332 79.193 33.9189 80.2 39.2687 80.2C45.92 80.2 52.1498 78.6236 57.8932 75.513C63.558 72.4071 68.1898 68.1153 71.8072 62.7318C64.614 63.193 57.2077 64.5342 49.5235 66.7271C41.5846 69.0095 33.7938 72.12 26.1328 76.0542"
  />
  <path
    fill="currentColor"
    d="M97.5323 13.3388V13.2824C97.5323 7.63059 101.923 3 107.963 3C114.003 3 118.339 7.57412 118.339 13.2259V13.2824C118.339 18.9341 113.948 23.5647 107.908 23.5647C101.868 23.5647 97.5323 18.9906 97.5323 13.3388ZM113.832 13.3388V13.2824C113.832 9.8753 111.372 7.03294 107.903 7.03294C104.434 7.03294 102.03 9.81882 102.03 13.2259V13.2824C102.03 16.6894 104.489 19.5318 107.959 19.5318C111.428 19.5318 113.832 16.7459 113.832 13.3388Z"
  />
  <path
    fill="currentColor"
    d="M123.281 3.33881H132.368C134.633 3.33881 136.338 3.93645 137.487 5.09881C138.381 6.00704 138.83 7.14587 138.83 8.47763V8.5341C138.83 10.7506 137.653 12.087 136.259 12.8259C138.524 13.7059 139.923 15.0706 139.923 17.7106V17.767C139.923 21.4047 137.014 23.2212 132.6 23.2212H123.29V3.33881H123.281ZM134.55 9.22116C134.55 7.88469 133.545 7.1741 131.725 7.1741H127.473V11.3765H131.442C133.341 11.3765 134.545 10.7506 134.545 9.27292V9.21645L134.55 9.22116ZM135.638 17.1741C135.638 15.8376 134.689 15.0141 132.452 15.0141H127.477V19.3906H132.595C134.494 19.3906 135.643 18.7082 135.643 17.2306V17.1741H135.638Z"
  />
  <path
    fill="currentColor"
    d="M151.299 3.19763H155.268L163.656 23.2259H159.154L157.366 18.7647H149.089L147.301 23.2259H142.91L151.299 3.19763ZM155.829 14.9012L153.23 8.4541L150.632 14.9012H155.833H155.829Z"
  />
  <path
    fill="currentColor"
    d="M167.793 3.33881H172.434L177.58 11.7482L182.726 3.33881H187.367V23.2212H183.087V10.2376L177.58 18.7317H177.468L172.017 10.3223V23.2212H167.797V3.33881H167.793Z"
  />
  <path
    fill="currentColor"
    d="M199.891 3.19763H203.861L212.249 23.2259H207.747L205.959 18.7647H197.682L195.894 23.2259H191.503L199.891 3.19763ZM204.421 14.9012L201.823 8.4541L199.224 14.9012H204.426H204.421Z"
  />
  <path
    fill="currentColor"
    d="M202.18 77.6811V57.7311H211.3C213.836 57.7311 215.803 58.4436 217.114 59.7546C218.225 60.8661 218.824 62.4336 218.824 64.3146V64.3716C218.824 67.5921 217.085 69.6156 214.549 70.5561L219.422 77.6811H214.292L210.017 71.2971H206.569V77.6811H202.18ZM206.569 67.4211H211.015C213.152 67.4211 214.378 66.2811 214.378 64.5996V64.5426C214.378 62.6616 213.067 61.6926 210.929 61.6926H206.569V67.4211Z"
  />
  <path
    fill="currentColor"
    d="M182.374 77.6811V57.7311H197.422V61.6356H186.735V65.6826H196.14V69.5871H186.735V73.7766H197.565V77.6811H182.374Z"
  />
  <path
    fill="currentColor"
    d="M167.827 77.6811V61.7781H161.756V57.7311H178.286V61.7781H172.216V77.6811H167.827Z"
  />
  <path
    fill="currentColor"
    d="M139.953 77.6811V57.7311H144L153.348 70.0146V57.7311H157.68V77.6811H153.946L144.285 64.9986V77.6811H139.953Z"
  />
  <path
    fill="currentColor"
    d="M120.147 77.6811V57.7311H135.195V61.6356H124.508V65.6826H133.913V69.5871H124.508V73.7766H135.338V77.6811H120.147Z"
  />
  <path
    fill="currentColor"
    d="M107.742 78.0232C101.871 78.0232 97.5105 73.4917 97.5105 67.7632V67.7062C97.5105 62.0347 101.785 57.3892 107.913 57.3892C111.675 57.3892 113.926 58.6432 115.779 60.4672L112.986 63.6877C111.447 62.2912 109.879 61.4362 107.884 61.4362C104.521 61.4362 102.099 64.2292 102.099 67.6492V67.7062C102.099 71.1262 104.464 73.9762 107.884 73.9762C110.164 73.9762 111.561 73.0642 113.128 71.6392L115.921 74.4607C113.869 76.6552 111.589 78.0232 107.742 78.0232Z"
  />
  <path fill="currentColor" d="M307.234 50.6811V30.7311H311.624V46.6911H321.57V50.6811H307.234Z" />
  <path
    fill="currentColor"
    d="M282.296 50.6812L290.846 30.5887H294.893L303.443 50.6812H298.854L297.03 46.2067H288.594L286.77 50.6812H282.296ZM290.162 42.3307H295.463L292.812 35.8612L290.162 42.3307Z"
  />
  <path fill="currentColor" d="M273.919 50.6811V30.7311H278.308V50.6811H273.919Z" />
  <path
    fill="currentColor"
    d="M259.172 50.6811V34.7781H253.101V30.7311H269.631V34.7781H263.561V50.6811H259.172Z"
  />
  <path
    fill="currentColor"
    d="M231.298 50.6811V30.7311H235.345L244.693 43.0146V30.7311H249.025V50.6811H245.291L235.63 37.9986V50.6811H231.298Z"
  />
  <path
    fill="currentColor"
    d="M211.492 50.6811V30.7311H226.54V34.6356H215.853V38.6826H225.258V42.5871H215.853V46.7766H226.683V50.6811H211.492Z"
  />
  <path
    fill="currentColor"
    d="M188.486 50.6811V30.7311H196.267C202.537 30.7311 206.869 35.0346 206.869 40.6491V40.7061C206.869 46.3206 202.537 50.6811 196.267 50.6811H188.486ZM196.267 34.6926H192.875V46.7196H196.267C199.858 46.7196 202.28 44.2971 202.28 40.7631V40.7061C202.28 37.1721 199.858 34.6926 196.267 34.6926Z"
  />
  <path fill="currentColor" d="M178.399 50.6811V30.7311H182.788V50.6811H178.399Z" />
  <path
    fill="currentColor"
    d="M166.354 50.9662C163.333 50.9662 160.283 49.9117 157.889 47.7742L160.483 44.6677C162.278 46.1497 164.159 47.0902 166.439 47.0902C168.235 47.0902 169.318 46.3777 169.318 45.2092V45.1522C169.318 44.0407 168.634 43.4707 165.299 42.6157C161.281 41.5897 158.687 40.4782 158.687 36.5167V36.4597C158.687 32.8402 161.594 30.4462 165.67 30.4462C168.577 30.4462 171.056 31.3582 173.08 32.9827L170.8 36.2887C169.033 35.0632 167.294 34.3222 165.613 34.3222C163.931 34.3222 163.048 35.0917 163.048 36.0607V36.1177C163.048 37.4287 163.903 37.8562 167.351 38.7397C171.398 39.7942 173.678 41.2477 173.678 44.7247V44.7817C173.678 48.7432 170.657 50.9662 166.354 50.9662Z"
  />
  <path
    fill="currentColor"
    d="M139.452 50.6811V30.7311H154.5V34.6356H143.812V38.6826H153.217V42.5871H143.812V46.7766H154.642V50.6811H139.452Z"
  />
  <path
    fill="currentColor"
    d="M118.144 50.6811V30.7311H127.264C129.8 30.7311 131.767 31.4436 133.078 32.7546C134.189 33.8661 134.788 35.4336 134.788 37.3146V37.3716C134.788 40.5921 133.049 42.6156 130.513 43.5561L135.386 50.6811H130.256L125.981 44.2971H122.533V50.6811H118.144ZM122.533 40.4211H126.979C129.116 40.4211 130.342 39.2811 130.342 37.5996V37.5426C130.342 35.6616 129.031 34.6926 126.893 34.6926H122.533V40.4211Z"
  />
  <path
    fill="currentColor"
    d="M98.394 50.6811V30.7311H106.545C111.305 30.7311 114.183 33.5526 114.183 37.6281V37.6851C114.183 42.3021 110.592 44.6961 106.118 44.6961H102.783V50.6811H98.394ZM102.783 40.7916H106.26C108.455 40.7916 109.737 39.4806 109.737 37.7706V37.7136C109.737 35.7471 108.369 34.6926 106.175 34.6926H102.783V40.7916Z"
  />
</svg>
